import React, { useEffect, useState } from 'react'
import { actionDeleteAdmin, actionFetchAdmins } from '../../../actions/admins';
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import { Button, ImageBuffer, Loader, PageHeader, Pagination } from '../../../components';
import moment from 'moment'
import toast from 'react-hot-toast';
import { AppDispatch, RootState } from '../../../reducers/store';
import { StateAdminParams } from '../../../types/admin/adminParams';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdminsTableHeader } from '../../../utils/constants';
import { emptyDisplay, users } from '../../../assets';

import './viewAdmins.css'

interface DeletePostParams {
  detailId: string;
  firstName: string;
}

const ViewAdmins = ({user}: any) => {
  const dispatch                                              = useDispatch<AppDispatch>();
  const location                                              = useLocation();
  const searchParams                                          = new URLSearchParams(location.search);
  const page                                                  = searchParams.get("page") || 1
  const {isLoading, getAllAdmins, numberOfPages, totalNumber} = useSelector((state: RootState) => state.adminList);
  const [allPosts, setAllPosts]                               = useState<StateAdminParams[]>(getAllAdmins);
  const [isOpen, setIsOpen]                                   = useState<{ [key: number]: boolean }>({})
  // const [page, setPage]                                    = useState<number>(1);

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }
  
  const handleDeletePost = ({detailId, firstName}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this user ${firstName}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeleteAdmin({detailId}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== detailId));
          // Show success toast after successfully deleting the post
          toast.success('User deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting post: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchAdmins({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  // hide the admin display
  const filteredAdmins = getAllAdmins?.filter((detail) => {
    if (user?.username !== "sanmexm" && detail.username === "sanmexm") {
      return false;
    }

    return true;
  });
  // hide the admin display
  const adjustedTotalNumber = filteredAdmins?.length || 0;

  if(!filteredAdmins?.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
          <div className='empty-profile-card-header'>
            <span><DoNotDisturbAltRounded /></span>
            <h1> No Admin Found </h1>
          </div>
          <Button buttonWrapper="button-wrapper" linkButton linkTo="/users/create-user" linkClass="link-wrapper" linkName="create user" />
      </div>
    </>
  )

  return (
    <>
      <title>Admins</title>
      <PageHeader title="Admins" description="Welcome to the Admins" download="Download Report" />
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Admins</h3>
        </div>
        
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {AdminsTableHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredAdmins.map((detail, index) => {
                const postImage = `${process.env.REACT_APP_BACKEND_ADMIN_IMAGE_URL}${detail?.selectedFile}` || users;
              return(
                <tr key={index}>
                  <td data-cell="image">
                  <div className="table-image">
                    {isLoading ? <Loader /> : (
                      <ImageBuffer src={postImage} alt='post image'/>
                    )}
                  </div>
                </td>
                  <td data-cell="first name">{detail.firstName}</td>
                  <td data-cell="last name">{detail.lastName}</td>
                  <td data-cell="username">{detail.username}</td>
                  <td data-cell="emailAddress">{detail.emailAddress}</td>
                  <td data-cell="created">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="updated">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/admins/edit-admin/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit Admin</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, firstName: detail.firstName }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}

        <Pagination actionGet={actionFetchAdmins} page={page} numberOfPages={numberOfPages} totalNumber={adjustedTotalNumber} />
      </div>
    </>
  )
}

export default ViewAdmins